// features/booking/bookingSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllBookings } from "../services/api"; // adjust if needed

export const fetchBookings = createAsyncThunk("booking/fetchBookings", async () => {
  const res = await getAllBookings();
  return res.data.booking; // assuming `res.data.booking` is the array
});

const bookingSlice = createSlice({
  name: "booking",
  initialState: {
    bookings: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookings.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBookings.fulfilled, (state, action) => {
        state.status = "succeeded";

        // Preserve the original booking structure to handle both app users and random users
        state.bookings = action.payload.map((booking) => {
          // For cancelled bookings, use hostActivityData if available, otherwise use activityId
          const activityData = booking.hostActivityData || booking.activityId;
          
          return {
            // Preserve the original booking structure
            ...booking,
            // Add extracted fields for backward compatibility
            bookingId: activityData?.bookingId,
            price: activityData?.price,
            selectedDate: activityData?.selectedDate,
            startTime: activityData?.startTime,
            endTime: activityData?.endTime,
            pitchDetail: activityData?.pitchDetail,
            sportName: booking.slot?.sport?.name,
            facilityId: booking.slot?.facility?._id,
            // Add cancellation type identification
            cancellationType: booking.isCancelled ? 
              (booking.cancelledByUser === true ? 'user' : 
               booking.cancelledBy && booking.cancelledByUser === false ? 'facility' : 
               'unknown') : null,
          };
        });
        console.log("Bookings data:", state.bookings);
      })
      
      .addCase(fetchBookings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
  
});

// Make sure these selectors access the correct path in the state
export const selectAllBookings = (state) => state.booking?.bookings || [];
export const selectBookingStatus = (state) => state.booking?.status || "idle";
export const selectBookingError = (state) => state.booking?.error || null;

export default bookingSlice.reducer;

function formatTimeUTC(dateString) {
  const date = new Date(dateString);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHour = hours % 12 || 12;
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
  return `${formattedHour}:${formattedMinutes} ${ampm}`;
}